import React from 'react';
import './styles.css';
import CardHelper from "../../helpers";

function CardTalent(props) {
  return (
    <div className={'card card-talent'}>
      <div className={'card-container'}>
        <div className={'preview-container'}>
          {props.cover !== '' &&
          <div
            className='card-cover'
            style={{ backgroundImage: `url(${props.cover})`, backgroundSize: 'cover' }}
          />
          }
        </div>
      </div>
      <div className='card-labels-container'>
        { CardHelper.createTitle(props.title || '', true)}
        { CardHelper.createSubTitle(props.subtitle || '')}
      </div>
    </div>
  );
}

export default CardTalent;



// WEBPACK FOOTER //
// ./src/components/CardNew/cardTypes/CardTalents/index.js